import React from 'react';
import {Container, ContainerProps} from './index';
import {UniqueIdentifier} from '@dnd-kit/core';
import {defaultAnimateLayoutChanges, useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import {HomepageGroupType} from '../../../../enums';
import cx from 'classnames';

export function DroppableContainer({
    children,
    disabled,
    id,
    items,
    ...props
}: ContainerProps & {
    disabled?: boolean;
    id: UniqueIdentifier;
    items: UniqueIdentifier[];

    title: string;
    type: HomepageGroupType;
    isHidden?: boolean;
}) {
    const {active, attributes, listeners, setNodeRef, transition, transform} = useSortable({
        id,
        data: {
            type: 'container',
            children: items,
            itemType: props.type
        },
        animateLayoutChanges: defaultAnimateLayoutChanges
    });

    return (
        <Container
            id={id}
            ref={disabled ? undefined : setNodeRef}
            count={items.length}
            componentClasses={cx({
                'pui-homepage-droppable-container': active?.id === id
            })}
            style={{
                transition,
                transform: CSS.Translate.toString(transform)
            }}
            handleProps={{
                ...attributes,
                ...listeners
            }}
            {...props}
        >
            {children}
        </Container>
    );
}
